import React from 'react';

interface IScrollerItemProps {
  width?: string;
  marginRight?: string;
  className?: string;
}

const ScrollerItem: React.FC<React.PropsWithChildren<IScrollerItemProps>> = ({
  children,
  width = '32',
  marginRight = '3',
  className = '',
}) => {
  return (
    <div className={`w-${width} mr-${marginRight} ${className}`}>
      {children}
    </div>
  );
};
export default ScrollerItem;
